import { Button, Flex, Icon, Text } from "@chakra-ui/react"
import React from "react"
import { useTranslation } from "react-i18next"
import { IconType } from "react-icons"

interface Props {
  icon: IconType
  title: string
  description: string
  onRetry?: () => void
  buttonText?: string
}

const CloudImageBrowserErrorScreen: React.FC<Props> = ({
  icon,
  description,
  title,
  onRetry,
  buttonText,
}) => {
  const { t } = useTranslation()

  const actionText =
    buttonText ??
    t(
      "components.cloudProvider.common.browser.CloudImageBrowserErrorScreen.Retry"
    )

  return (
    <Flex
      flex={1}
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      px={8}
      pb={16}
    >
      <Flex
        gap={6}
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        textAlign="center"
        maxWidth="400px"
      >
        <Flex
          borderRadius="full"
          width="80px"
          height="80px"
          alignItems="center"
          justifyContent="center"
          backgroundColor="blackAlpha.50"
        >
          <Icon as={icon} boxSize={8} color="gray.800" />
        </Flex>
        <Text fontWeight="semibold" fontSize="2xl">
          {title}
        </Text>
        <Text>{description}</Text>
        {onRetry && (
          <Button
            className="cloud-provider-error-retry"
            colorScheme="primary"
            onClick={onRetry}
          >
            {actionText}
          </Button>
        )}
      </Flex>
    </Flex>
  )
}

export default CloudImageBrowserErrorScreen
